import { useAppSelector } from "@/store/hooks"
import gsap from "gsap"
import React, { useEffect, useRef } from "react"
import jaiDrop from "@/audio/jail-drop.mp3"
import lockAudioSrc from "@/audio/lock.mp3"
import lockOpenAudioSrc from "@/audio/lock-open.mp3"
import moveAudioSrc from "@/audio/property-card-movement.mp3"
import { createEffectAudio } from "@/utils/audioManager"
import classNames from "classnames"

interface MortgageOverlayProps {
  propertyOrder: number
}
export const MortgageOverlay: React.FC<MortgageOverlayProps> = ({
  propertyOrder,
}) => {
  return null
  // Same as HouseItemOriginal — one per board cell, so it takes only what it
  // reads.
  const propChangesAppliedAnimation = useAppSelector(
    (state) => state.global.animationData.propChangesAppliedAnimation
  )
  const tempCount = useAppSelector((state) => state.global.tempCount)
  const mortgagedProperties = useAppSelector(
    (state) => state.global.myGame?.situation?.mortgagedProperties
  )
  const ref = useRef<HTMLDivElement | null>(null)
  const lockRef = useRef<HTMLSpanElement | null>(null)
  const myMortgageAnimation =
    propChangesAppliedAnimation.mortgageAnimations.find(
      (anim) => anim.propertyOrder === propertyOrder
    )
  const isMortgaged =
    mortgagedProperties?.includes(propertyOrder)
  useEffect(() => {
    if (!myMortgageAnimation) return
    if (!lockRef.current || !ref.current) return
    const prevDelay = myMortgageAnimation.delay / 1000
    if (myMortgageAnimation.type === "un-mortgaged") {
      const timeline = gsap.timeline({})
      const lockOpenAudio = createEffectAudio(lockOpenAudioSrc)
      const moveAudio = createEffectAudio(moveAudioSrc)

      timeline
        .set(ref.current, { y: 0, x: 0, scale: 1, opacity: 1 })

        .set(lockRef.current, { className: "lock" })
        .to(lockRef.current, 0, {
          className: "lock unlocked",
          delay: prevDelay + 0.5,
          onComplete: () => {
            lockOpenAudio.play()
          },
        })
        .to(ref.current, {
          onStart: () => {
            moveAudio.play()
          },
          opacity: 0,
          x: -1000,
          delay: prevDelay + 0.7,
          ease: "power4.inOut",
          duration: 1,
        })
    }
    if (myMortgageAnimation.type === "mortgated") {
      const timeline = gsap.timeline({})
      const dropAudio = createEffectAudio(jaiDrop)
      const lockAudio = createEffectAudio(lockAudioSrc)

      timeline
        .set(ref.current, { y: -500, scale: 5, opacity: 0 })
        .to(ref.current, { opacity: 1, delay: prevDelay, duration: 0.0001 })
        .set(lockRef.current, { className: "lock unlocked", opacity: 0 })
        .to(ref.current, {
          onStart: () => {
            dropAudio.play()
          },
          y: 0,
          scale: 1,
          ease: "bounce",
          duration: 0.4,
        })
        .set(lockRef.current, { opacity: 1, delay: 0.4 })
        .to(lockRef.current, 0, {
          className: "lock",
          delay: 0.4,
          onComplete: () => {
            lockAudio.play()
          },
        })
    }
  }, [
    isMortgaged,
    propertyOrder,
    myMortgageAnimation,
    propChangesAppliedAnimation,
    tempCount,
  ])

  return (
    <div
      ref={ref}
      className="h-full w-full z-[5]  box-content absolute bg-[#5f0000] grayscale-[0.7] "
    >
      <div className="container opacity-50">
        <span
          ref={lockRef}
          className={classNames("lock", { unlocked: !isMortgaged })}
        ></span>
      </div>
    </div>
  )
}
